import { render, staticRenderFns } from "./SearchCard.vue?vue&type=template&id=27499798&scoped=true&"
import script from "./SearchCard.vue?vue&type=script&lang=js&"
export * from "./SearchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27499798",
  null
  
)

export default component.exports